require('./default.scss');

require('../app.js');